import insane from 'insane'
import Languages from '@cospired/i18n-iso-languages'
import enLang from '@cospired/i18n-iso-languages/langs/en.json'
import deLang from '@cospired/i18n-iso-languages/langs/de.json'

Languages.registerLocale(enLang)
Languages.registerLocale(deLang)

export function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false }
  const opt = { ...defaultOptions, ...options }
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language
  if (!navigatorLocale) {
    return undefined
  }
  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()
  return trimmedLocale
}

export function getSupportedLocales() {
  const modules = import.meta.glob('@/lang/*.json', { eager: true })

  return Object.keys(modules).reduce((acc, fileName) => {
    const lang = fileName.split('/').pop().replace(/\.\w+$/, '')
    acc[lang] = fileName
    return acc
  }, {})
}

export const TO_FLAG = {
  en: 'gb',
  de: 'de',
  fr: 'fr',
  it: 'it',
}

export const INSANE_CONFIG = {
  allowedClasses: { a: ['link'] },
  allowedAttributes: {
    ...insane.defaults.allowedAttributes,
    a: ['class', 'href', 'name', 'target', 'rel'],
  },
}

export { Languages }
